import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { finalize, takeUntil, tap } from 'rxjs/operators';

import { PageNames } from 'src/app/configs/page-names.enum';
import { QueryStringTypesEnum } from 'src/app/configs/query-string-types';
import {
  ComparisonOperator,
  GetEnumValuesDto,
  GetSmartSmsRequestRecipientsByRequestIdDto,
  LogicalComparisonOperator,
  PaginatedListOfGetSmartSmsRequestRecipientsByRequestIdDto,
  SmartSmsStatisticsByRequestIdRecipientIdItem,
} from 'src/app/core/api/models';
import { SmartSmsRequestRecipientScheduledMessagesDetail } from 'src/app/core/api/models/smart-sms-request-recipient-scheduled-messages-detail';
import {
  ExcelService,
  SmartSmsRequestsService,
} from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import { DateTimeService } from 'src/app/core/services/date-time.service';
import { DefaultSearchValueService } from 'src/app/core/services/default-search-value.service';
import { AppDomService } from 'src/app/core/services/dom.service';
import { DynamicTabService } from 'src/app/core/services/dynamic-tab.service';
import { SendSmartDetailsByDeliveryService } from 'src/app/core/services/sendSmartDetailsByDelivery.service';
import { SmartSmsShareMemoryService } from 'src/app/core/services/smart-sms-shareMemory.service';
import { TabsDynamicComponent } from 'src/app/layout/components/tabs-dynamic/tabs-dynamic.component';
import { BaseIndexPageComponent } from 'src/app/pages/shared/base/components/base-index-page.component';
import { TranslationService } from './../../../../i18n/translation.service';
import { CreateSmartSmsDetailExcelDialogComponent } from './create-smart-sms-detail-excel/create-smart-sms-detail-excel-dialog.component';
import { CreateSmartSmsDetailTableExcelDialogComponent } from './create-smart-sms-detail-table-excel/create-smart-sms-detail-table-excel-dialog.component';

@Component({
  selector: 'app-send-smart-sms-details',
  templateUrl: './send-smart-sms-details.component.html',
  styleUrls: ['./send-smart-sms-details.component.scss'],
  standalone: false,
})
export class SendSmartDetailsComponent
  extends BaseIndexPageComponent
  implements OnInit
{
  //#region properties
  @Input() requestId: number;
  @Input() campaignTitle: string;

  fields = 'pages.sendSmartSMS.form.fields.';
  pageName = PageNames.sendSmartSMS;
  data: any = [];
  showCharts: boolean = false;
  modelWithPagination$: Observable<PaginatedListOfGetSmartSmsRequestRecipientsByRequestIdDto>;
  items$: Observable<Array<GetSmartSmsRequestRecipientsByRequestIdDto>>;
  totalNumbersCount: number = 0;
  SmartSmsStatusEnumValues: GetEnumValuesDto[] = [];
  SmsAggregatorEnumValues: GetEnumValuesDto[] = [];
  protected onDestroy$ = new Subject<void>();

  @Output('closePage') output_closPage = new EventEmitter<boolean>();

  //#endregion

  constructor(
    protected currentService: SmartSmsRequestsService,
    public translationService: TranslationService,
    public excelFileService: ExcelService,
    protected smartSmsShareMemory: SmartSmsShareMemoryService,

    private dynamicTabService: DynamicTabService,
    protected defaultSearchValueService: DefaultSearchValueService,
    protected tabsDynamicComponent: TabsDynamicComponent
  ) {
    super();
  }
  //#region init methods

  ngOnInit() {
    try {
      if (
        !this.requestId &&
        this.defaultSearchValueService.SmartSmsRequestDetailsRequestId != 0
      ) {
        this.requestId =
          this.defaultSearchValueService.SmartSmsRequestDetailsRequestId;
        this.defaultSearchValueService.SmartSmsRequestDetailsRequestId = 0;
      }

      super.ngOnInit(false, false);
      this.pageConfig.isAddBtnWithLoading = false;
      this.pageConfig.showAddBtn = false;
      this.pageConfig.showAuditBtn = false;
      this.pageConfig.showHelpBtn = false;
      this.campaignTitle = this.smartSmsShareMemory.getScheduledMessageTitle();
      this.requestId = this.smartSmsShareMemory.getScheduledMessageId();

      // اگر کاربر با انتخاب گزینه در پرنت آمده بود آیدی پرنت رو به یوآرال اضافه میکنیم و اگر با یوآرال آمده بود آیدی پرنت رو از یوآرال میخونیم
      this.showParent = false;
      this.setParentQueryString();
      if (this.requestId > 1 && !window.location.search.includes('key-'))
        this.location.go(
          window.location.pathname +
            window.location.search +
            (window.location.search.includes('?') ? '&' : '?') +
            QueryStringTypesEnum.Details_key +
            '=' +
            this.requestId +
            '_' +
            this.campaignTitle
        );
      else {
        if (window.location.search.includes('key-')) {
          let params = this.routingState.parseQueryString(
            window.location.search
          );
          for (const [key, value] of Object.entries(params)) {
            if (key.startsWith('key-')) {
              this.requestId = +value.toString().split('_')[0];
              this.campaignTitle = decodeURIComponent(
                value.toString().split('_')[1]
              );
            }
          }
        }
      }
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.smartSms);
    }
  }

  configTableColumns() {
    this.tableColumns = [
      {
        title: 'common.title',
        name: 'title',
        hasSearch: true,
      },
      {
        title: 'common.operator',
        name: 'operator',
        hasSearch: true,
        type: 'enum',
        enumName: 'SmsAggregator',
        noSorting: true,
        wrap: true,
      },
      {
        title: 'common.numbersCount',
        name: 'numbersCount',
        hasSearch: true,
        noNumberSeparator: true,
        type: 'number',
      },
      {
        title: 'common.persianPrice',
        name: 'persianPrice',
        hasSearch: false,
        noSorting: true,
        type: 'number',
      },
      {
        title: 'common.englishPrice',
        name: 'englishPrice',
        hasSearch: false,
        noSorting: true,
        type: 'number',
      },
      {
        title: 'common.smsCount',
        name: 'statistics.totalSmsCount',
        hasSearch: false,
        noSorting: true,
        type: 'number',
      },
      {
        title: 'common.partCount',
        name: 'statistics.totalPartCount',
        hasSearch: false,
        noSorting: true,
        type: 'number',
      },
      {
        title: 'common.receivedMessage',
        name: 'receivedMessage',
        hasSearch: true,
      },
      {
        title: 'common.status',
        name: 'status',
        hasSearch: true,
        type: 'enum',
        enumName: 'SmartSmsStatus',
      },
      {
        title: 'common.statusDatetime',
        name: 'statusDatetime',
        hasSearch: true,
        type: 'dateTime',
      },
      {
        title: 'common.expireDateTime',
        name: 'expireTime',
        hasSearch: true,
        type: 'dateTime',
      },
      {
        title: 'common.startDateTime',
        name: 'startDateTime',
        hasSearch: true,
        type: 'dateTime',
      },
      {
        title: 'common.endDateTime',
        name: 'endDateTime',
        hasSearch: true,
        type: 'dateTime',
        dateDefaultValue: DateTimeService.getTodayDate().toUTC(),
        isRequired: true,
        wrap: true,
      },
    ];
  }

  setDefaultTableSort() {
    try {
      const isExistsSortObject = this.sortObject.some((item) =>
        item.columnName.includes('startDateTime')
      );
      if (!isExistsSortObject)
        this.sortObject.push({ columnName: 'startDateTime', sort: 1 });
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.smartSms);
    }
  }
  defaultFilters = [
    {
      field: 'endDateTime',
      operator: 3,
      value: DateTimeService.getTodayDate().toUTC(),
    },
    {
      field: 'endDateTime',
      operator: 4,
      value: DateTimeService.getSimpleTodayDate().toUTC(),
    },
  ];
  setDefaultDateSearch() {
    try {
      let greaterThan = {
        field: 'endDateTime',
        operator: 3,
        value: DateTimeService.getTodayDate().toUTC(),
      };

      let lessThan = {
        field: 'endDateTime',
        operator: 4,
        value: DateTimeService.getSimpleTodayDate().toUTC(),
      };

      this.comparisonObjects.push({
        comparisonObjects: [greaterThan, lessThan],
        logicalComparisonOperator: LogicalComparisonOperator.And,
      });
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.smartSms);
    }
  }

  onClearQueryString() {
    this.tabsDynamicComponent.refreshTab('smartDetail');
  }
  //#endregion

  //#region apis

  getPaginationApi(): Observable<PaginatedListOfGetSmartSmsRequestRecipientsByRequestIdDto> {
    return this.currentService
      .smartSmsRequestsGetSmartSmsRequestRecipientsByRequestId({
        body: {
          ...this.getBaseModelWithPaginationParams(),
          smartSmsRequestId: this.requestId,
        },
      })
      .pipe(tap((items: any) => this.calculateTotalSum(items?.data?.items)));
  }

  getEnumsValues() {
    this.getEnumValuesApi('SmartSmsStatus')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((values) => (this.SmartSmsStatusEnumValues = values));

    this.getEnumValuesApi('SmsAggregator')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((values) => (this.SmsAggregatorEnumValues = values));
  }

  smartSmsDetailExcelReportApi() {
    this.unSubs();
    this.excelFileService
      .excelCreateSmartSmsStatisticsExcelGet()
      .pipe(this.basePipeOperators())
      .subscribe((res) => {
        if (res) {
          let data = {
            title: `${this.pageVocabs}smartSmsDetailExcel`,
            id: this.requestId,
          };

          const modalResult = this.dialogService.openModal({
            component: CreateSmartSmsDetailExcelDialogComponent,
            data: data,
          });

          modalResult
            .afterClosed()
            .pipe(
              takeUntil(this.onDestroy$),
              tap(() => {
                AppDomService.removeModalScrollClassFromHtml();
              })
            )
            .subscribe();
        }
      });
  }

  smartSmsDetailTableExcelReportApi() {
    this.unSubs();
    this.excelFileService
      .excelCreateSmartSmsRequestRecipientsExcelGet()
      .pipe(this.basePipeOperators())
      .subscribe((res) => {
        if (res) {
          let data = {
            title: `${this.pageVocabs}smartSmsDetailTableExcel`,
            id: this.requestId,
            comparisonObjects: this.comparisonObjects,
            sortObject: this.sortObject,
          };

          const modalResult = this.dialogService.openModal({
            component: CreateSmartSmsDetailTableExcelDialogComponent,
            data: data,
          });

          modalResult
            .afterClosed()
            .pipe(
              takeUntil(this.onDestroy$),
              tap(() => {
                AppDomService.removeModalScrollClassFromHtml();
              })
            )
            .subscribe();
        }
      });
  }

  onShowCharts() {
    if (this.pageConfig.loading == true) return;
    this.unSubs();

    const filterBody: {
      EndDateTime?: string;
      StartDateTime?: string;
      SmartSmsRequestId?: any;
    } = { SmartSmsRequestId: this.requestId };

    // find endDateTime values and applies filter
    this.comparisonObjects.forEach((item) => {
      if (item?.comparisonObjects[0]?.field == 'endDateTime') {
        const GreaterThanItem = item?.comparisonObjects?.find(
          (item) => item.operator == ComparisonOperator.GreaterThan
        );
        if (GreaterThanItem)
          filterBody.StartDateTime = DateTimeService.toUTC(
            GreaterThanItem.value
          );

        const LessThanItem = item?.comparisonObjects?.find(
          (item) => item.operator == ComparisonOperator.LessThan
        );
        if (LessThanItem)
          filterBody.EndDateTime = DateTimeService.toUTC(LessThanItem.value);
      }
    });

    this.currentService
      .smartSmsRequestsGetPeriodicSmartSmsRequestStatistics(filterBody)
      .pipe(
        takeUntil(this.onDestroy$),
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe((res) => {
        if (res) {
          this.data = {
            model: res?.data,
            title: this.campaignTitle,
            filters: filterBody,
          };
          this.showCharts = true;
        }
      });
  }

  //#endregion

  onShowDetailsByDelivery(
    items: Array<SmartSmsStatisticsByRequestIdRecipientIdItem>,
    scheduledMessageDetails: SmartSmsRequestRecipientScheduledMessagesDetail[]
  ) {
    try {
      this.unSubs();
      let data = { model: items };
      SendSmartDetailsByDeliveryService.items = items;
      SendSmartDetailsByDeliveryService.scheduledMessageDetails =
        scheduledMessageDetails;
      this.dynamicTabService.setNewTab('');
      this.dynamicTabService.setNewTab('sendSmartDetailsByDelivery');
      this.dynamicTabService.setActiveTab('sendSmartDetailsByDelivery');
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.smartSms);
    }
  }

  onExcelReport() {
    this.smartSmsDetailExcelReportApi();
  }

  onTableExcelReport() {
    this.smartSmsDetailTableExcelReportApi();
  }

  calculateTotalSum(items: GetSmartSmsRequestRecipientsByRequestIdDto[]) {
    try {
      this.totalNumbersCount = items
        .map((item) => item.numbersCount)
        .reduce((acc, curr) => {
          return acc + curr;
        }, 0);
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.smsReport);
    }
  }

  onCloseCharts() {
    this.showCharts = false;
  }

  onRefresh() {
    this.getTableData();
  }

  onClose() {
    this.output_closPage.emit(true);
  }
}
